export const TSCategoryToColor = {
	"TD": "#0099FF",
	"TS": "#81C056",
	"H1": "#F6C445",
	"H2": "#EE7932",
	"H3": "#D64A27",
	"H4": "#AC32F6",
	"H5": "#D535A9"
}